<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import { useSiteStore } from '~/stores/site.store';
import { LockIcon } from '../../design-system/icons/index';
import { ChevronRightIcon } from '@heroicons/vue/24/outline';
import ExternalIcon from '~/components/design-system/icons/ExternalIcon.vue';

const rgStore = useRgStore();
const site = useSiteStore();
const { $t, $toggleChat } = useNuxtApp();

const restrictionMessage = computed(() =>
  rgStore.hasPartialRegLock
    ? $t('partial-reg-lock-restricted')
    : $t('only-permitted-access-withdrawal'),
);

withDefaults(defineProps<{ disableAction?: boolean }>(), {
  disableAction: false,
});
</script>

<template>
  <div>
    <div class="mx-2">
      <div
        class="text-base-priority text-sm flex flex-col justify-center items-center flex-wrap pt-3"
      >
        <div class="flex justify-center">
          <div class="border-gold-500 border-4 rounded-full p-2 flex">
            <LockIcon class="w-10 h-10 text-gold-500" />
          </div>
        </div>
        <!--        restriction title-->
        <p
          v-if="$slots.restrictionTitle"
          class="pt-4 line-height-3 mb-2 text-center text-sm"
        >
          <slot name="restrictionTitle" />
        </p>
        <p v-else class="pt-4 line-height-3 mb-2 text-center text-sm">
          {{ $t('account-lock-restricted') }}
        </p>
        <!--        restriction message-->
        <p
          v-if="$slots.restrictionMessage"
          class="text-center mb-4 line-height-3 text-sm"
        >
          <slot name="restrictionMessage" />
        </p>
        <p
          v-else
          class="text-center mb-4 line-height-3 text-sm"
          v-html="$t(restrictionMessage)"
        ></p>
      </div>

      <div
        class="flex justify-between bg-base rounded-md mb-4 pl-3 cursor-pointer py-1"
        @click="$toggleChat()"
      >
        <div class="flex items-center mt-0.5 mb-0.5 text-base-priority">
          <ExternalIcon class="w-6 mt-1 mr-3" icon-name="chat-support" />
          <p class="text-sm my-0 font-bold mr-1 line-height-1">
            {{ $t('chat') }}
          </p>
          <p class="my-0 text-sm line-height-1">{{ $t('to-live-support') }}</p>
        </div>
        <ChevronRightIcon
          class="w-4 dark:text-light-50 text-dark-700 mr-2 stroke-2 stroke-current"
        />
      </div>
    </div>
    <slot name="action" />
    <div v-if="!$slots.action" class="bg-base w-full px-2 py-1">
      <Button
        v-if="disableAction"
        class="w-full my-2 justify-center"
        type="primary"
        rounded="sm"
        @click="site.deactivateModal()"
      >
        {{ $t('close') }}
      </Button>
    </div>
  </div>
</template>
